import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { OPPORTUNITIES, PDF_BG } from "../data/content";
import SectionBg from "./SectionBg";

export default function Opportunities() {
    return (
        <section
            id="opportunities"
            className="relative py-24 md:py-40 overflow-hidden"
            data-testid="opportunities-section"
        >
            <SectionBg src={PDF_BG.opportunities} opacity={0.6} />
            <div className="pointer-events-none absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[400px] rounded-full bg-[#FF6B35]/10 blur-[160px]" />
            <div className="max-w-[1440px] mx-auto px-6 md:px-12 relative">
                <div className="grid grid-cols-12 gap-6 md:gap-12 mb-12 md:mb-16">
                    <div className="col-span-12 md:col-span-4 text-xs uppercase tracking-[0.3em] text-[#FF6B35] font-mono">
                        Opportunities at JAF
                    </div>
                    <h2 className="col-span-12 md:col-span-8 min-w-0 max-w-full font-display font-bold text-[1.62rem] leading-[1.14] tracking-normal break-words [overflow-wrap:anywhere] sm:text-5xl sm:leading-[1.05] sm:tracking-tight lg:text-6xl">
                        Show up. Show off. <span className="gradient-text">Walk away changed.</span>
                    </h2>
                </div>

                <div className="space-y-3 md:space-y-4">
                    {OPPORTUNITIES.map((op, i) => (
                        <motion.a
                            key={op.title}
                            href="#contact"
                            initial={{ opacity: 0, x: -30 }}
                            whileInView={{ opacity: 1, x: 0 }}
                            viewport={{ once: true, margin: "-50px" }}
                            transition={{ delay: i * 0.08, duration: 0.7 }}
                            className="group relative grid grid-cols-12 gap-4 md:gap-6 items-center px-5 sm:px-6 md:px-10 py-6 md:py-9 rounded-3xl border border-white/10 hover:border-[#FF6B35]/60 bg-[#141414]/60 hover:bg-[#141414] transition-all duration-500"
                            data-testid={`opportunity-row-${i}`}
                        >
                            <div className="col-span-12 sm:col-span-2 md:col-span-1 font-mono text-xs uppercase tracking-[0.18em] sm:tracking-[0.25em] text-[#FF6B35]">
                                0{i + 1}
                            </div>
                            <div className="col-span-12 sm:col-span-10 md:col-span-5 min-w-0 max-w-full font-display text-[1.22rem] leading-tight font-bold tracking-normal break-words [overflow-wrap:anywhere] group-hover:text-[#FF6B35] transition-colors sm:text-xl md:text-3xl md:tracking-tight">
                                {op.title}
                            </div>
                            <div className="col-span-12 md:col-span-5 min-w-0 text-zinc-400 text-sm md:text-base leading-relaxed [overflow-wrap:anywhere]">
                                {op.copy}
                            </div>
                            <div className="hidden md:flex col-span-1 justify-end">
                                <ArrowUpRight
                                    size={28}
                                    className="text-zinc-500 group-hover:text-[#FF6B35] group-hover:rotate-45 transition-all duration-500"
                                />
                            </div>
                        </motion.a>
                    ))}
                </div>
            </div>
        </section>
    );
}
